<template>
    <div>
        <div class="mx-2  pt-2 py-2">
            <h1 class="flex justify-center text-2xl 100vh  mb-5 pt-10 ">Update Hospital</h1>
            <form class="max-w-md mx-auto" @submit.prevent="submit">
                <div class="mb-5">
                    <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Hospital Name</label>
                    <input type="text" v-model="name" id="username"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                        placeholder="Hospital Name" required />
                </div>
                <div class="mb-5">
                    <label for="number" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Code</label>
                    <input type="text" v-model="code" id="username"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                        placeholder="Code" required />
                    <span class="text-red-500 text-sm">{{ errorMessagecode }}</span>

                </div>
                <div class="mb-5">
                    <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Contact Person</label>
                    <input type="text" v-model="contact_person" id="displayname"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                        placeholder="Contact Person" />
                </div>
                <div class="mb-5">
                    <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Phone</label>
                    <MaskInput type="text"  mask="+92 (###) ####-###" v-model="Phone"  :value="Phone"
                        id="displayname"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" />
                </div>
                <div class="mb-5">
                    <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Fax</label>
                    <MaskInput type="text" mask="+92 (###) ####-###" v-model="fax" :value="fax" id="displayname"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                         />
                </div>
                <div class="mb-5">
                    <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Address</label>
                    <input type="text" v-model="address" id="displayname"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                        placeholder="Address" />
                </div>
                <div class="mb-5">
                    <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        No of Beds</label>
                    <input type="number" v-model="no_of_beds" id="displayname"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                        placeholder="No of Beds" />
                    <span class="text-red-500 text-sm">{{ errorMessage }}</span>
                </div>
                <div class="mb-5">
                    <!-- -->
                    <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select
                        Category</label>
                    <select v-model="category" style="height: 40px"
                        class=" bg-white rounded-lg  border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option value=""></option>
                        <option>THQ
                        </option>
                        <option> DHQ
                        </option>
                    </select>
                </div>
                <div class="mb-5">
                    <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select
                        Site Type</label>
                    <select id="Site_Type" v-model="site_type_id"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option selected>Choose a site type</option>
                        <option v-for="site in selectSites" :key="site.id" :value="site.id">{{ site.type }}
                        </option>
                    </select>
                </div>
                <div class="mb-5">
                    <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        City</label>
                    <select id="countries" @change="getdistrict" v-model="distric_id"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option selected>Choose a sites</option>
                        <option v-for="site in city" :key="site.id" :value="site.id">{{ site.name }}
                        </option>
                    </select>
                </div>
                <div class="mb-5">
                    <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Tehsil/Location</label>
                    <select id="countries" v-model="tehsil_id"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option selected>Choose a sites</option>
                        <option v-for="teh in tehsils" :key="teh.id" :value="teh.id">{{ teh?.name }}
                        </option>
                    </select>
                </div>

                <div class="mb-5">
                    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Email</label>
                    <input type="email" id="email" v-model="email"
                        class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                        placeholder="name@flowbite.com" />
                </div>
                <div class="flex items-center">
                    <label class="relative flex items-center mb-5 cursor-pointer">
                        <input type="checkbox" v-model="is_active" value="" class="sr-only peer">
                        <div
                            class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
                        </div>
                        <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Active</span>
                    </label>
                </div>
                <div class="flex items-center justify-center">
                    <router-link to="hospital"
                        class="text-white mb-5  bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        Back</router-link>
                    <button type="submit" :disabled="isdisabled" :class="{ 'bg-gray-500 ': isdisabled }"
                        class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        Update Hospital</button>
                </div>
            </form>
        </div>
    </div>
</template>


<script setup>
import $ from 'jquery';
import 'select2';
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import axiosInstce from "@/plugins/axios"
import { useRouter } from 'vue-router'; // Import the useRouter function from vue-router
const router = useRouter();
const city = ref([])
const selectSites = ref([])
const name = ref()
const email = ref()
const tehsil_id = ref()
const is_active = ref()
const site_type_id = ref()
const category = ref()
const contact_person = ref()
const code = ref()
const Phone = ref('')
const address = ref()
const fax = ref()
const no_of_beds = ref()
const distric_id = ref()
const hospitalId = ref()
const tehsils = ref([])
import Swal from 'sweetalert2';
const errorMessagecode = ref('');
import { MaskInput } from "vue-3-mask";

const isdisabled = ref(false)
const errorMessage = ref('');
watch(code, (newValue) => {
    // Check if the value is a number
    if (isNaN(newValue)) {
        errorMessagecode.value = 'Invalid input. Please enter a number.';
        isdisabled.value = true;
    } else {
        const codeString = String(newValue);
        if (/^\d{5}$/.test(codeString)) {
            // Valid 5-digit number
            errorMessagecode.value = '';
            isdisabled.value = false;
        } else {
            // Invalid input or not a 5-digit number
            errorMessagecode.value = 'Code must be a 5-digit number.';
            isdisabled.value = true;
        }
    }
});

watch(no_of_beds, (newValue) => {
    if (newValue <= 0 || isNaN(newValue)) {
        errorMessage.value = 'No of beds must be greater than 0.';
        isdisabled.value = true;
    } else {
        errorMessage.value = '';
        isdisabled.value = false;
    }
});
const getHospital = () => {
    axiosInstce.get(`hospital/${hospitalId.value}`)
        .then(response => {
            const hospital = response.data.data.hospital;
            fax.value = hospital.fax
            no_of_beds.value = hospital.no_of_beds
            name.value = hospital.name
            address.value = hospital.address
            Phone.value = hospital.phone
            code.value = hospital.code
            contact_person.value = hospital.contact_person
            is_active.value = hospital.is_active
            email.value = hospital.email
            distric_id.value = hospital.tehsil?.district?.id
            site_type_id.value = hospital.hospital_type?.id
            category.value = hospital.category
            getdistrict()
            tehsil_id.value = hospital.tehsil.id
        })
        .catch(error => {
            console.error('Error fetching sites:', error);
        });
}
const getdistrict = () => {
    axiosInstce.get(`districts/${distric_id.value}/tehsils`)
        .then(response => {
            tehsils.value = response.data.data;
        })
        .catch(error => {
            console.error('Error fetching sites:', error);
        });
}
const getSites = () => {
    axiosInstce.get(`/site-types-paginate/10`)
        .then(response => {
            const site = response.data.data.data;
            const siteNames = site.map(sites => sites);
            selectSites.value = siteNames;
        })
        .catch(error => {
            console.error('Error fetching sites:', error);
        });
}

const getcity = () => {
    axiosInstce.get(`/all-districts`)
        .then(response => {
            const citys = response.data.data;
            city.value = citys
        })
        .catch(error => {
            console.error('Error fetching hospitals:', error);
        });
}
const submit = async () => {

    try {
        const response = await axiosInstce.put(`/hospitals/${hospitalId.value}`, {
            name: name.value,
            address: address.value,
            email: email.value,
            no_of_beds: no_of_beds.value,
            district_id: distric_id.value,
            site_type_id: site_type_id.value,
            fax: fax.value,
            Phone: Phone.value,
            is_active: is_active.value === true ? 1 : 0,
            category: category.value,
            contact_person: contact_person.value,
            code: code.value,
            tehsil_id: tehsil_id.value
        });
        Swal.fire({
            toast: true,
            title: 'Hospital Updated successfully.',
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        router.push({ name: 'Hospital' });

    } catch (error) {
        console.error('Error fetching Hospital info:', error);
        Swal.fire({
            toast: true,
            title: error.response.data.message,
            icon: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }
    // form.value = '';
};
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
    const authData = authStore.authData;
    permissions.value = authStore.authData.permissions

});
const hasCanSignSiteToUser = computed(() => permissions.value.some(permission => permission.name === 'can assign site to user'));
const hascanassignroletouser = computed(() => permissions.value.some(permission => permission.name === 'can assign role to user'));
onMounted(async () => {
    const id = router.currentRoute.value.params.id;
    hospitalId.value = id
    getcity()
    getHospital()
    getSites()
})

onMounted(async () => {
    await authStore.handlepermission()
})

onUnmounted(async () => {
    await authStore.handlepermission()
})
</script>

<style></style>